export default __webpack_public_path__ + "static/media/gallery_09.aa19c0ef.jpg";